import {
    GET_API_KEY_EVENTS_SUCCESS,
    GET_API_KEY_EVENTS_FAILURE
} from "./actions";

const initialState = {
    getApiKeyEventsResult: {
        success: true
    },
    apiKeyEventsResult: {
        Items: []
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_API_KEY_EVENTS_SUCCESS:
            return { ...state, getApiKeyEventsResult: { success: true }, apiKeyEventsResult: action.payload.apiKeyEventResults };
        case GET_API_KEY_EVENTS_FAILURE:
            return {
                ...state, getApiKeyEventsResult: { success: false, ...action.payload.error }, apiKeyEventsResult: {
                    Items: []
                }
            };
        default:
            return state;
    }
};
